import React from 'react';
import { motion } from 'framer-motion';
import SafeIcon from '../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';

const { FiUser, FiShield, FiStar, FiUmbrella, FiZap, FiHeart, FiAward } = FiIcons;

const USPSection = () => {
  const features = [
    {
      icon: FiUser,
      title: "Personalized Itineraries",
      description: "Every journey is handcrafted around your unique preferences, interests, and needs. Your trip is as unique as you are!"
    },
    {
      icon: FiShield,
      title: "Exceptional 24/7 Service",
      description: "Our Canadian-based experts are on call day and night—before, during, and after your trip. Travel with confidence."
    },
    {
      icon: FiStar,
      title: "Exclusive Access & VIP Perks",
      description: "Thanks to our global partnerships, enjoy upgrades, private experiences, and premium accommodations not found on public booking sites."
    },
    {
      icon: FiUmbrella,
      title: "Comprehensive Travel Care",
      description: "Flights, hotels, cruises, insurance, activities—we handle it all. No more stress, no more surprises."
    },
    {
      icon: FiZap,
      title: "Proactive Problem Solving",
      description: "Flight canceled? Plans change? Our team acts fast so you never miss a beat."
    },
    {
      icon: FiHeart,
      title: "Sustainable, Responsible Travel",
      description: "Choose from eco-friendly options and support local communities—travel with a conscience."
    },
    {
      icon: FiAward,
      title: "Curated Luxury Experiences",
      description: "Private island retreats, chef-led culinary tours, and more—indulge in the extraordinary."
    }
  ];

  return (
    <section className="py-16 relative bg-gradient-to-br from-gray-900 via-black to-purple-900">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
          viewport={{ once: true }}
          className="text-center mb-12"
        >
          <h2 className="text-3xl sm:text-4xl font-bold text-white mb-6">
            Why Savvy Canadian Travelers Choose <span className="text-transparent bg-clip-text bg-gradient-to-r from-orange-400 via-pink-400 to-yellow-400">SeetaLuxuryEscape</span>
          </h2>
        </motion.div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
          {features.map((feature, index) => (
            <motion.div
              key={index}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.6, delay: index * 0.1 }}
              viewport={{ once: true }}
              whileHover={{ scale: 1.05, y: -5 }}
              className="backdrop-blur-xl bg-black/60 rounded-2xl p-6 border border-orange-500/30 shadow-xl hover:shadow-2xl hover:border-orange-400/50 transition-all duration-300 cursor-pointer"
            >
              <div className="bg-gradient-to-r from-orange-500 to-pink-500 w-12 h-12 rounded-full flex items-center justify-center mb-4">
                <SafeIcon icon={feature.icon} className="text-white text-xl" />
              </div>
              <h3 className="text-white font-semibold text-lg mb-3">{feature.title}</h3>
              <p className="text-gray-300 leading-relaxed">{feature.description}</p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default USPSection;